export default "__VITE_PUBLIC_ASSET__1d4f48cf__"